import React from "react";
import { motion } from "framer-motion";
import { FaBus } from "react-icons/fa";

import transportImg from "../assets/bus2.jpeg";

const Transport = () => {
  return (
    <section className="bg-[#f8fbff]">

      {/* ================= HERO ================= */}

      <section className="bg-gradient-to-r from-[#07294d] to-[#0b3d68] py-20">

        <div className="max-w-7xl mx-auto px-6 text-center">

          <motion.div
            initial={{ opacity: 0, y: 35 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >

            <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6 text-white text-4xl">

              <FaBus />

            </div>

            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold">

              Cambridge International School

            </p>

            <h1 className="text-5xl md:text-6xl font-black text-white mt-6">

              Transportation

            </h1>

            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          </motion.div>

        </div>

      </section>

      {/* ================= CONTENT ================= */}

      <section className="max-w-6xl mx-auto px-6 py-16">

        <div className="bg-white rounded-[30px] shadow-xl overflow-hidden">

          {/* Image */}

          <img
            src={transportImg}
            alt="School Transport"
            className="w-full h-[420px] object-cover"
          />

          {/* Content */}

          <div className="p-10">

            <span className="inline-block px-5 py-2 rounded-full bg-yellow-100 text-yellow-700 text-sm font-semibold mb-6">

              School Transport

            </span>

            <h2 className="text-4xl font-black text-[#07294d] mb-6">

              Safe & Secure Transportation

            </h2>

            <div className="w-20 h-1 bg-[#d4af37] rounded-full mb-8"></div>

            <p className="text-gray-600 text-lg leading-9">
                            The School Provides the most secure transport facility
              with every bus having experienced driver, conductor and
              a Female attendant (maid). Apart from this all buses are
              under GPS monitoring, CCTV surveillance and have speed
              governors installed.

            </p>

          </div>

        </div>

      </section>

    </section>

  );
};

export default Transport;